// Module
var code = `<a target="{{target}}" ui-state="state" ui-state-params="params" class="whitespace-nowrap inline-flex items-center text-sm text-harvustorange"> <span ng-if="label" translate>{{label}}</span> <span ng-if="content">{{content}}</span> <material-icon name="arrow_forward" classes="ui-link harvust-icon-orange"></material-icon> </a> `;
// Exports
export default code;